module.exports = __webpack_public_path__ + "img/appleStoreBg.60349470.png";